import React, { PureComponent } from 'react'
import { connect } from 'react-redux'

import { localize } from 'helpers/translator'
import FullOverlay from 'views/overlay/full_overlay/FullOverlay'
import Bodymovin from 'components/bodymovin/bodymovin'
import flocabularyActions from 'redux/actions/flocabularyActions'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'

import PropTypes from 'prop-types'
import styles from './flocabulary_limit_reached_overlay.scss'
import animationPaths from 'animations/paths'

class FlocabularyLimitReachedOverlay extends PureComponent {

	createAsset() {
		return (
			<Bodymovin
				path={animationPaths.FLOCABULARY_LIMIT_REACHED}
				loop={true}
			>
				<div className={styles.animation}></div>
			</Bodymovin>
		)
	}

	render() {

		return (
			<FullOverlay
				headerWithBorder={true}
				assetSource={this.createAsset()}
				assetWidth='80%'
				primaryTextButton={localize('flocabulary_limit_reached_overlay_nudgemyadmin')}
				primaryActionHandler={this.props.actions.nudgeMyAdmin}
				secondaryTextButton={localize('action_button_nothanks')}
				secondaryActionHandler={this.props.actions.dismiss}
			/>
		)
	}
}

FlocabularyLimitReachedOverlay.propTypes = {
	actions: PropTypes.shape({
		nudgeMyAdmin: PropTypes.func.isRequired,
		dismiss: PropTypes.func.isRequired,
	}).isRequired,
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		nudgeMyAdmin: flocabularyActions.flocabularyLimitReachedOverlayNudgeSelected,
		dismiss: flocabularyActions.flocabularyLimitReachedOverlayDismissSelected,
	}, dispatch)
}

export default connect(null, mapDispatchToProps)(FlocabularyLimitReachedOverlay)

export { FlocabularyLimitReachedOverlay }
